import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AreaShell } from "@/components/area/AreaShell";
import { ClienteAccess } from "@/components/area/ClienteAccess";
import { ClienteDashboard } from "@/components/area/ClienteDashboard";
import { cliente, crmError, getClienteSession, setClienteSession, clearClienteSession } from "@/lib/crm";

export default function AreaCliente() {
  const location = useLocation();
  const navigate = useNavigate();
  const [session, setSession] = useState(getClienteSession());
  const [consuming, setConsuming] = useState(false);
  const [linkError, setLinkError] = useState("");

  const consumed = useRef(null);

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    if (!token || consumed.current === token) return;
    consumed.current = token;
    setConsuming(true);
    cliente
      .consumeMagicLink(token)
      .then((d) => {
        setClienteSession(d.session_token);
        setSession(d.session_token);
      })
      .catch((e) => setLinkError(crmError(e, "Link non valido o già utilizzato. Richiedine uno nuovo.")))
      .finally(() => {
        setConsuming(false);
        navigate("/area-cliente", { replace: true });
      });
  }, [location.search, navigate]);

  const login = (token) => {
    setClienteSession(token);
    setSession(token);
  };
  const logout = () => {
    clearClienteSession();
    setSession(null);
  };

  if (consuming) {
    return (
      <AreaShell testId="area-cliente-consuming" title="Area Clienti" subtitle="Verifica del link in corso…">
        <Loader2 className="mx-auto h-8 w-8 animate-spin text-zr-green" />
      </AreaShell>
    );
  }
  if (session) return <ClienteDashboard onLogout={logout} />;
  return <ClienteAccess onLogin={login} initialError={linkError} />;
}
